var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteItAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.425 48C3.245 48 2.2125 47.55 1.3275 46.65C0.4425 45.75 0 44.7 0 43.5V4.5C0 3.3 0.4425 2.25 1.3275 1.35C2.2125 0.449999 3.245 0 4.425 0H54.575C55.755 0 56.7875 0.449999 57.6725 1.35C58.5575 2.25 59 3.3 59 4.5V43.5C59 44.7 58.5575 45.75 57.6725 46.65C56.7875 47.55 55.755 48 54.575 48H4.425ZM4.425 43.5H54.575V10.8H4.425V43.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteItAssets);
export default __webpack_public_path__ + "static/media/whiteItAssets.f19398937694a4f3a7eccfe8dfe342a3.svg";
export { ForwardRef as ReactComponent };